import { useParams } from 'react-router';
import { useQuery } from '@tanstack/react-query';
import { ProfileStatusView } from '@/components/common';
import { adminKYCApi } from '@/api';
import { Loading } from '@/components/common';
import { useSelector } from 'react-redux';

export const ProfileStatusAdmin = () => {
  const { id } = useParams();
  const investor = useSelector((state) => state.investor);
  const { data, isLoading, refetch } = useQuery({
    queryKey: ['getInvestorQuestionnaires'],
    queryFn: () => adminKYCApi.getInvestorQuestionnaires(id),
    refetchInterval: 10000,
    refetchOnWindowFocus: true
  });
  const { data: sumSubRes } = useQuery({
    queryKey: ['getInvestorSumSubStatus'],
    queryFn: () => adminKYCApi.getInvestorSumSubStatus(id)
  });

  if (isLoading) return <Loading />;

  if (!isLoading) {
    return (
      <ProfileStatusView
        data={data}
        investor={investor}
        sumSubStatusRes={sumSubRes}
        refetchQuests={refetch}
        adminView
      />
    );
  }

  return null;
};
